import React from "react";
import { Button } from "@akashnetwork/ui/components";
import type { LinkProps } from "next/link";
import Link from "next/link";

import { useServices } from "@src/context/ServicesProvider";
import { useAddFundsVerifiedLoginRequiredEventHandler } from "@src/hooks/useAddFundsVerifiedLoginRequiredEventHandler";
import type { FCWithChildren } from "@src/types/component";

export const AddFundsLink: FCWithChildren<
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> &
    LinkProps & {
      children?: React.ReactNode;
      disabled?: boolean;
    } & React.RefAttributes<HTMLAnchorElement>
> = props => {
  const { analyticsService } = useServices();
  const whenLoggedInAndVerified = useAddFundsVerifiedLoginRequiredEventHandler();

  return props.disabled ? (
    <Button className={props.className} disabled>
      {props.children}
    </Button>
  ) : (
    <Link
      {...props}
      onClick={event => {
        analyticsService.track("add_funds_btn_clk");
        whenLoggedInAndVerified(props.onClick || (() => {}))(event);
      }}
    />
  );
};
